import { useContext, useEffect, useState } from "react";
import { ButtonStyled } from "../../../../../components/Button/styles";
import { UserContext } from "../../../../../providers/UserContext";
import { Link } from "react-router-dom";

export const FollowCard = ({ wer, userId }: any) => {
	const { unfollowUser, followUser, user, checkIfUserFollow } =
		useContext(UserContext);

	const [isFollower, setIsFollower] = useState(false);

	useEffect(() => {
		const verifyIsFollow = async () => {
			const isFollowResponse = await checkIfUserFollow({
				followerId: wer.id,
				userId: user!.id,
			});

			setIsFollower(isFollowResponse ? true : false);
		};

		verifyIsFollow();
	});

	return (
		<div className="item">
			<Link to={`/perfil/${wer.username}`}>
				<img src={wer.image} alt={`follower${wer.id}`} />
			</Link>
			<h4 className="username">@{wer.username}</h4>

			{user?.id !== wer.id && (
				<abbr title={isFollower ? "Desseguir" : "Seguir"}>
					<ButtonStyled
						onClick={() => {
							isFollower ? unfollowUser(wer.id) : followUser(wer.id);
						}}
					>
						{isFollower ? "Desseguir" : "Seguir"}
					</ButtonStyled>
				</abbr>
			)}

		</div>
	);
};
